<template>
  <v-container fluid>
    <v-row class="mt-2">
      <v-col cols="12">
        <v-card dark outlined>
          <v-card-title class="secondary py-1 text-subtitle-1">
            <v-icon left dense> mdi-tag </v-icon>
            Tag Configuration
            <v-spacer />
          </v-card-title>

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <div class="mt-5">
                <label
                  ><B>Event Name :- </B>
                  {{
                    selectedEvent.EventName ? selectedEvent.EventName : "N/A"
                  }}</label
                >
              </div>

              <div class="mt-5 mb-5">
                <label
                  ><B>StallHolder Name :- </B>
                  {{ stallholderName ? stallholderName : "N/A" }}</label
                >
              </div>

              <v-text-field
                v-model="editedItem.StallTagName"
                label="Tag Name"
                :rules="tagNameRules"
                required
              ></v-text-field>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="handleClickCancel">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" @click="submitForm">
                  Submit
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import "izitoast/dist/css/iziToast.min.css";
import iziToast from "izitoast/dist/js/iziToast.min.js";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "TagConfiguration",
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    tagData: {
      type: Object,
      default: null,
    },
    stallholderData: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    Action: "",
    editedItem: {
      EventId: "",
      StallholderId: "",
      StallTagName: "",
      StallTagId: "",
    },
    selectedStallholderObj: {},
    tagNameRules: [(v) => !!v || "Tag Name is required"],
  }),

  computed: {
    ...mapState("filter", ["globalEventFilter"]),
    ...mapState("admin", ["currentStallholder"]),

    selectedEvent() {
      return this.globalEventFilter;
    },

    stallholderName() {
      return this.selectedStallholderObj.StallholderName || "";
    },
  },

  created() {
    try {
      if (this.id && this.id !== "0") {
        this.Action = "update";
        if (this.tagData) {
          this.editedItem = { ...this.tagData };
        }
      } else {
        this.Action = "create";
      }

      // Resolve stallholder from prop or store
      if (this.stallholderData) {
        this.selectedStallholderObj = this.stallholderData;
        this.editedItem.StallholderId = this.stallholderData.StallholderId;
      } else if (this.currentStallholder) {
        this.selectedStallholderObj = this.currentStallholder;
        this.editedItem.StallholderId = this.currentStallholder.StallholderId;
      }
    } catch (error) {
      console.error("Error in created hook:", error);
      iziToast.error({
        title: "Error",
        message: "Failed to initialize tag configuration",
        position: "topRight",
      });
    }
  },

  mounted() {
    this.setEventSelectorDisabled(true);
  },

  beforeDestroy() {
    this.setEventSelectorDisabled(false);
  },

  methods: {
    ...mapActions("admin", ["createEvent"]),
    ...mapActions("filter", ["initialLogin"]),
    ...mapMutations("admin", [
      "setEventSelectorDisabled",
      "setCurrentEventManagementTab",
    ]),

    submitForm() {
      try {
        if (this.$refs.form.validate()) {
          this.editedItem.EventId = this.selectedEvent.EventId;

          let properties;
          if (this.Action === "create") {
            properties = {
              EventId: this.editedItem.EventId,
              StallholderId: this.editedItem.StallholderId,
              StallTagName: this.editedItem.StallTagName,
            };
          } else {
            properties = {
              StallTagId: this.editedItem.StallTagId,
              EventId: this.editedItem.EventId,
              StallholderId: this.editedItem.StallholderId,
              StallTagName: this.editedItem.StallTagName,
            };
          }

          const event_item = [
            {
              Type: "StallTag",
              Action: this.Action,
              Properties: properties,
            },
          ];

          this.createEvent({ event_items: event_item })
            .then(() => {
              iziToast.success({
                title: "Tag",
                message: "Successfully saved record!",
                position: "topRight",
              });
              this.redirectReload();
            })
            .catch((err) => {
              console.error("Error saving tag:", err);
              iziToast.warning({
                title: "Tag",
                message: "Failed to save record!",
                position: "topRight",
              });
            });
        }
      } catch (e) {
        console.error(e);
      }
    },

    handleClickCancel() {
      this.setCurrentEventManagementTab("Tags");
      this.$router.push({ name: "EventManagement" });
    },

    redirectReload() {
      this.initialLogin().then(() => {});
      this.setCurrentEventManagementTab("Tags");
      this.$router.push({ name: "EventManagement" });
    },
  },
};
</script>

<style scoped>
h1 {
  color: #a09c94;
  font-family: sans-serif;
}
</style>
